// @flow
import * as React from 'react';
import { CircularProgress, InputAdornment } from '@mui/material';
import { useDebouncedEffect } from '@coverright/utils';
import { X } from '@phosphor-icons/react';
import { ComponentProps, useEffect, useState } from 'react';
import { TextInput } from './text-input';

type Props = Omit<ComponentProps<typeof TextInput>, 'onChange' | 'value'> & {
  value: string;
  onChange: (value: string) => void;
};
export const SearchInput = (props: Props) => {
  const {value, onChange, ...rest} = props
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    searchTerm !== props.value && setSearchTerm(props.value || '');
  }, [props.value])

  useDebouncedEffect(() => {
    searchTerm !== props.value && props.onChange(searchTerm);
  }, 400, [searchTerm])

  return (
    <TextInput
      className={'mt-0'}
      fullWidth
      hideTick
      placeholder={props.placeholder || 'Search'}
      {...rest}
      InputProps={{
        ...rest.InputProps,
        onFocus: e => e.target.select(),
        endAdornment:
          <InputAdornment position="end">
            {!props.loading && !!searchTerm && <X size={16} style={{cursor: 'pointer'}} onClick={() => {
              setSearchTerm('');
            }} />}
            {props.loading && <CircularProgress size={16} color={'inherit'} />}
          </InputAdornment>,
      }}
      value={searchTerm}
      onChange={e => setSearchTerm(e.target.value || '')}
    />
  );
};
